<template>
  <v-container grid-list-sm fluid>
    <v-layout row wrap>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoVacio :titulo="tituloCompleto" />
          <v-card-text>
            <v-form ref="form1">
              <v-layout row wrap>
                <v-flex xs12 md12>
                  <SelectCaja
                    :model="itemActivo.Id_Caja"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarCaja"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md5>
                  <v-flex v-if="esModuloVenta">
                    <div v-if="esVentaContado">
                      <SelectCliente
                        :model="itemActivo.Id_Cliente"
                        @seleccionarItem="seleccionarCliente"
                      />
                    </div>
                    <div v-else>
                      <SelectCliente
                        :model="itemActivo.Id_Cliente"
                        :rules="[rules.requerido]"
                        @seleccionarItem="seleccionarCliente"
                      />
                    </div>
                  </v-flex>
                  <v-flex v-else>
                    <SelectCliente
                      :model="itemActivo.Id_Cliente"
                      @seleccionarItem="seleccionarCliente"
                      :readonly="true"
                    />
                  </v-flex>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <SelectTipoComprobanteNumeroEmitido
                    nombreModulo="[VENTA, CAJA, EESS]"
                    :id_PuntoVenta="itemActivo.Id_PuntoVenta"
                    :letra="itemActivo.Letra"
                    :numero="itemActivo.Numero"
                    :rules="[rules.requerido]"
                    :conAccionEditarNumero="true"
                    @seleccionarTipoComprobante="seleccionarTipoComprobante"
                    @seleccionarCondicionVenta="seleccionarCondicionVenta"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap>
              <v-flex xs12 md7>
                <Grilla
                  :columnas="grillaHeaders_Articulos"
                  :itemsDB="itemActivo.Articulos"
                  :loading="grillaLoading_Articulos"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Articulos"
                />
              </v-flex>
              <v-flex xs12 md4 offset-md1>
                <Grilla
                  :columnas="grillaHeaders_Pagos"
                  :itemsDB="itemActivo.Pagos"
                  :loading="grillaLoading_Pagos"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Pagos"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs12 md6>
                <NavBarArticulo
                  v-if="(!esRecibo || sysId_TipoIva == 'M') && !esModuloCaja"
                  :id_PuntoVenta="itemActivo.Id_PuntoVenta"
                  @seleccionarItem="seleccionarTecla"
                />
              </v-flex>
              <v-flex xs12 md1>
                <v-btn
                  v-if="(!esRecibo || sysId_TipoIva == 'M') && !esModuloCaja"
                  rounded
                  block
                  color="primary"
                  @click="modalArticuloEjecutarAccion('Mostrar')"
                >
                  Buscar
                  <v-icon right>shopping_cart</v-icon>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md4
                offset-md1
                v-if="esVentaContado || esRecibo || esModuloCaja"
              >
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Tarjeta)"
                >
                  Tarjeta
                  <v-icon right>credit_card</v-icon>
                </v-btn>
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Cheque)"
                >
                  Cheque
                  <v-icon right>local_atm</v-icon>
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Efectivo)"
                >
                  Efectivo
                  <v-icon right>attach_money</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs6 md1>
                <Importe
                  label="Gravado"
                  :model="itemActivo.Gravado"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaBasico"
                  :model="itemActivo.IvaBasico"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaDiferencial"
                  :model="itemActivo.IvaDiferencial"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Exento"
                  :model="itemActivo.Exento"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Impuesto Interno"
                  :model="itemActivo.ImpuestoInterno"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Tasa A"
                  :model="itemActivo.TasaA"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Percepción IIBB"
                  :model="itemActivo.PercepcionIb"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs12 md3 offset-md2 text-right>
                <span class="display-2 font-weight-light">
                  Total {{ itemActivo.Total | esMoneda }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-text-field
                  ref="controlFocoNota"
                  label="Notas"
                  v-model="itemActivo.Nota"
                  :rules="[rules.maximo500]"
                  @keyup.enter="finalizar"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 offset-md3 class="text-right">
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="ejecutarAccion('Inicializar')"
                >
                  Cancelar
                  <v-icon right>close</v-icon>
                </v-btn>
                <v-btn rounded color="primary" class="ma-1" @click="finalizar">
                  Finalizar
                  <v-icon right>done</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <ModalArticulo
      :activo="modalArticuloActivo"
      :id_Articulo="itemActivo.Id_Articulo"
      :nombreModulo="itemActivo.NombreModulo"
      :esVentaContado="esVentaContado"
      @ejecutarAccion="modalArticuloEjecutarAccion"
    />
    <ModalTipoPagoEfectivo
      :activo="modalTipoPagoEfectivoActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoEfectivoEjecutarAccion"
    />
    <ModalTipoPagoTarjeta
      :activo="modalTipoPagoTarjetaActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoTarjetaEjecutarAccion"
    />
    <ModalTipoPagoCheque
      :activo="modalTipoPagoChequeActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      :titular="itemActivo.RazonSocial"
      @ejecutarAccion="modalTipoPagoChequeEjecutarAccion"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
    <v-snackbar
      v-model="snackActivo"
      color="success"
      :timeout="3000"
      :vertical="true"
      >Generando el comprobante...
    </v-snackbar>
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import EncabezadoVacio from "@/components/EncabezadoVacio";
import PieCrud from "@/components/PieCrud";
import Grilla from "@/components/Grilla";
import Mensaje from "@/components/Mensaje";
import Importe from "@/components/Importe";
import SelectTipoComprobanteNumeroEmitido from "@/components/Sistema/SelectTipoComprobanteNumeroEmitido";
import SelectCliente from "@/components/Venta/SelectCliente";
import NavBarArticulo from "@/components/Stock/NavBarArticulo";
import ModalArticulo from "@/components/Stock/ModalArticulo";
import ModalTipoPagoEfectivo from "@/components/Caja/ModalTipoPagoEfectivo";
import ModalTipoPagoTarjeta from "@/components/Tarjeta/ModalTipoPagoTarjeta";
import ModalTipoPagoCheque from "@/components/Cartera/ModalTipoPagoCheque";
import SelectCaja from "@/components/Caja/SelectCaja";
export default {
  name: "VentaManual",
  components: {
    EncabezadoVacio,
    PieCrud,
    Grilla,
    Mensaje,
    Importe,
    SelectTipoComprobanteNumeroEmitido,
    SelectCliente,
    NavBarArticulo,
    ModalArticulo,
    ModalTipoPagoEfectivo,
    ModalTipoPagoTarjeta,
    ModalTipoPagoCheque,
    SelectCaja
  },
  data() {
    return {
      titulo: "Carga Manual de Ventas",
      itemVacio: {
        Id_PuntoVenta: 0,
        EstadoFiscal: "MANUAL",
        NombrePuntoVenta: "",
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_CondicionVenta: 0,
        NombreCondicionVenta: "",
        Id_Talonario: 0,
        Letra: "",
        Numero: "",
        Fecha: "",
        Id_Cliente: 0,
        RazonSocial: "",
        Id_TipoIva: "F",
        Cuit: "",
        Direccion: "",
        Id_TipoVenta: "",
        AlicuotaPercepcionIb: 0,
        SaldoActual: 0,
        Limite: 0,
        Id_Articulo: 0,
        Total: 0,
        Gravado: 0,
        IvaBasico: 0,
        IvaDiferencial: 0,
        Exento: 0,
        ImpuestoInterno: 0,
        TasaA: 0,
        PercepcionIb: 0,
        TotalPago: 0,
        TotalPagoPendiente: 0,
        Nota: "",
        Articulos: [],
        Pagos: [],
        Id_Caja: 0,
        FechaCaja: "",
        TurnoCaja: 0,
        NombreEmpleadoCaja: ""
      },
      itemActivo: {},
      itemsTipoPago: [],
      rules: {
        requerido: v => !!v || "Requerido",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres"
      },
      grillaHeaders_Articulos: [
        {
          text: "Artículo",
          value: "Nombre",
          width: "50%",
          sortable: false
        },
        { text: "Cantidad", value: "Cantidad", sortable: false },
        { text: "Precio", value: "Precio", mask: "esMoneda", sortable: false },
        { text: "Importe", value: "Importe", mask: "esMoneda", sortable: false }
      ],
      grillaLoading_Articulos: false,
      grillaHeaders_Pagos: [
        {
          text: "Pago",
          value: "NombreTipoPago",
          width: "50%",
          sortable: false
        },
        { text: "Importe", value: "Importe", mask: "esMoneda", sortable: false }
      ],
      grillaLoading_Pagos: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: "",
      loading: false,
      snackActivo: false,
      modalArticuloActivo: false,
      modalTipoPagoEfectivoActivo: false,
      modalTipoPagoTarjetaActivo: false,
      modalTipoPagoChequeActivo: false
    };
  },
  computed: {
    sysId_TipoIva() {
      return this.$store.state.sysId_TipoIva;
    },
    sysAlicuotaIvaBasico() {
      return this.$store.state.sysAlicuotaIvaBasico;
    },
    sysAlicuotaIvaDiferencial() {
      return this.$store.state.sysAlicuotaIvaDiferencial;
    },
    tituloCompleto() {
      return this.itemActivo.Id_Caja == undefined ||
        this.itemActivo.Id_Caja == 0
        ? this.titulo
        : this.titulo +
            " " +
            this.itemActivo.NombrePuntoVenta +
            " | Turno " +
            moment(this.itemActivo.FechaCaja)
              .locale("es")
              .format("DD/MM/YYYY") +
            "-" +
            this.itemActivo.TurnoCaja +
            " (" +
            this.itemActivo.NombreEmpleadoCaja +
            ")";
    },
    tituloIvaBasico() {
      return "Iva " + this.sysAlicuotaIvaBasico + "%";
    },
    tituloIvaDiferencial() {
      return "Iva " + this.sysAlicuotaIvaDiferencial + "%";
    },
    esDistribuidor() {
      return this.itemActivo.Id_TipoVenta == this.$id_TipoVenta_Distribuidor;
    },
    esModuloVenta() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_Venta;
    },
    esVentaContado() {
      return (
        this.esModuloVenta &&
        this.itemActivo.NombreCondicionVenta ==
          this.$nombreCondicionVenta_Contado
      );
    },
    esRecibo() {
      return (
        this.itemActivo.NombreTipoComprobante ==
        this.$nombreTipoComprobante_Recibo
      );
    },
    esModuloCaja() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_Caja;
    },
    esModuloEeSs() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_EeSs;
    },
    iResumenComprobante() {
      return (
        this.itemActivo.NombreTipoComprobante +
        " Nº " +
        this.itemActivo.Numero +
        " " +
        this.itemActivo.NombreCondicionVenta +
        (this.itemActivo.RazonSocial
          ? " a " + this.itemActivo.RazonSocial
          : " a Consumidor Final")
      );
    }
  },
  mounted() {
    this.ejecutarAccion("Inicializar");
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Guardar":
          this.mostrarMensaje(
            true,
            "ConfirmacionGuardar",
            "¿Quiere guardar el comprobante?",
            this.iResumenComprobante
          );
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "CancelarAviso":
          this.mostrarMensaje(false);
          break;
        case "Inicializar":
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.itemActivo.Articulos = [];
      this.itemActivo.Pagos = [];
      var promesa1 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectCaja");
        eventBus.$emit("inicializarSelectCliente");
        resolve();
      });
      var promesa2 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectTipoComprobanteNumeroEmitido");
        resolve();
      });
      promesa1.then(() => {
        promesa2.then(() => {
          eventBus.$emit("setearFocoSelectCaja");
        });
      });
    },
    seleccionarCaja(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.NombrePuntoVenta;
      this.itemActivo.Id_Caja = item.Id_Caja;
      this.itemActivo.FechaCaja = item.Fecha;
      this.itemActivo.TurnoCaja = item.Turno;
      this.itemActivo.NombreEmpleadoCaja = item.NombreEmpleado;
      if (this.itemActivo.Id_Caja == 0)
        eventBus.$emit("limpiarSelectTipoComprobanteNumeroEmitido");
      else {
        setTimeout(() => {
          eventBus.$emit("inicializarSelectTipoComprobanteNumeroEmitido");
        }, 100);
        setTimeout(() => {
          eventBus.$emit("setearFocoSelectCliente");
        }, 1500);
      }
    },
    seleccionarCliente(item) {
      this.itemActivo.Id_Cliente = item.Id_Cliente;
      this.itemActivo.RazonSocial = item.RazonSocial;
      this.itemActivo.Id_TipoIva = item.Id_TipoIva;
      this.itemActivo.Cuit = item.Cuit;
      this.itemActivo.Direccion = item.Direccion;
      this.itemActivo.Id_TipoVenta = item.Id_TipoVenta;
      this.itemActivo.AlicuotaPercepcionIb = item.AlicuotaPercepcionIb;
      this.itemActivo.SaldoActual = item.SaldoActual;
      this.itemActivo.Limite = item.Limite;
      this.seleccionarLetra();
    },
    seleccionarLetra(letra) {
      if (letra == null || "ABC".includes(this.itemActivo.Letra)) {
        if (this.sysId_TipoIva == "I")
          this.itemActivo.Letra = this.itemActivo.Id_TipoIva == "I" ? "A" : "B";
        else this.itemActivo.Letra = "C";
      } else this.itemActivo.Letra = letra;
    },
    seleccionarTipoComprobante(item) {
      if (item.NombreModulo != null) {
        this.itemActivo.NombrePuntoVenta = item.NombrePuntoVenta;
        this.itemActivo.NombreModulo = item.NombreModulo;
        this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
        this.itemActivo.NombreTipoComprobante = item.NombreTipoComprobante;
        this.itemActivo.Id_Talonario = item.Id_Talonario;
        this.itemActivo.PrefijoPuntoVenta = item.PrefijoPuntoVenta;
        this.itemActivo.Numero = item.NumeroActual;
        this.itemActivo.Fecha = item.Fecha;
        this.seleccionarLetra(item.Letra);
        this.cargarTiposPago();
      }
    },
    cargarTiposPago() {
      this.itemsTipoPago = [];
      this.grillaLoading_Pagos = true;
      HttpHelper.get("TipoPago/ListarPorModulo", {
        nombreModulo: this.itemActivo.NombreModulo
      })
        .then(response => {
          this.itemsTipoPago = response.data;
          this.grillaLoading_Pagos = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    seleccionarCondicionVenta(item) {
      this.itemActivo.Id_CondicionVenta = item.Id_CondicionVenta;
      this.itemActivo.NombreCondicionVenta = item.NombreCondicionVenta;
      if (!this.esVentaContado) {
        this.itemActivo.TotalPago = 0;
        this.itemActivo.Pagos = [];
      }
    },
    grillaBorrarItem_Articulos(item) {
      var ind = this.itemActivo.Articulos.findIndex(
        x => x.Id_Articulo == item.Id_Articulo
      );
      this.itemActivo.Articulos.splice(ind, 1);
      this.calcularTotal();
    },
    seleccionarTecla(item) {
      this.modalArticuloEjecutarAccion("Mostrar", item);
    },
    modalArticuloEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.itemActivo.Id_Articulo = item ? item.Id_Articulo : 0;
          this.modalArticuloActivo = true;
          break;
        case "Aceptar":
          this.agregarArticulo(item);
          this.modalArticuloActivo = false;
          break;
        case "Cerrar":
          this.modalArticuloActivo = false;
          break;
      }
    },
    agregarArticulo(item) {
      this.grillaLoading_Articulos = true;
      if (item.Importe > 0) {
        var gravado = 0;
        var ivaBasico = 0;
        var ivaDiferencial = 0;
        var exento = 0;
        var impuestoInterno = 0;
        var tasaA = 0;
        var percepcionIb = 0;
        impuestoInterno = item.Cantidad * item.ImpuestoInternoArticulo;
        tasaA = item.Cantidad * item.TasaAArticulo;
        gravado = item.Importe - impuestoInterno - tasaA;
        if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Gravado) {
          gravado = gravado / (1 + this.sysAlicuotaIvaBasico / 100);
          ivaBasico = gravado * (this.sysAlicuotaIvaBasico / 100);
        } else {
          if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Diferencial) {
            gravado = gravado / (1 + this.sysAlicuotaIvaDiferencial / 100);
            ivaDiferencial = gravado * (this.sysAlicuotaIvaDiferencial / 100);
          } else {
            exento = gravado;
            gravado = 0;
          }
        }
        if (this.esDistribuidor)
          percepcionIb = gravado * (item.AlicuotaPercepcionIb / 100);
        this.itemActivo.Articulos.push({
          Id_Articulo: item.Id_Articulo,
          Nombre: item.NombreArticulo,
          Cantidad: item.Cantidad,
          Precio: item.Precio,
          Importe: item.Importe,
          Gravado: gravado,
          IvaBasico: ivaBasico,
          IvaDiferencial: ivaDiferencial,
          Exento: exento,
          ImpuestoInterno: impuestoInterno,
          TasaA: tasaA,
          PercepcionIb: percepcionIb
        });
        this.calcularTotal();
        setTimeout(() => {
          this.$refs.controlFocoNota.focus();
        }, 100);
      }
      this.grillaLoading_Articulos = false;
    },
    calcularTotal() {
      this.itemActivo.Gravado = this.itemActivo.IvaBasico = this.itemActivo.IvaDiferencial = this.itemActivo.Exento = this.itemActivo.ImpuestoInterno = this.itemActivo.Total = this.itemActivo.TasaA = this.itemActivo.PercepcionIb = 0;
      this.itemActivo.Articulos.forEach(item => {
        this.itemActivo.Gravado += item.Gravado;
        this.itemActivo.IvaBasico += item.IvaBasico;
        this.itemActivo.IvaDiferencial += item.IvaDiferencial;
        this.itemActivo.Exento += item.Exento;
        this.itemActivo.ImpuestoInterno += item.ImpuestoInterno;
        this.itemActivo.TasaA += item.TasaA;
        this.itemActivo.PercepcionIb += item.PercepcionIb;
        this.itemActivo.Total += this.itemActivo.PercepcionIb;
        this.itemActivo.Total += item.Importe;
      });
      this.itemActivo.Total = Number(
        parseFloat(this.itemActivo.Total).toFixed(2)
      );
      if (this.esVentaContado || this.esRecibo) this.sugerirPagoEfectivo();
      else this.controlarLimite();
    },
    sugerirPagoEfectivo() {
      this.itemActivo.Pagos = [];
      this.agregarPago({
        NombreTipoPago: this.$nombreTipoPago_Efectivo,
        Importe: this.itemActivo.Total
      });
    },
    controlarLimite() {
      if (
        this.esModuloVenta &&
        !this.esRecibo &&
        this.itemActivo.Total >
          this.itemActivo.Limite - this.itemActivo.SaldoActual
      ) {
        this.mostrarMensaje(
          true,
          "Aviso",
          "Límite Superado",
          "El cliente supera su límite en CTA.CTE."
        );
      }
    },
    grillaBorrarItem_Pagos(item) {
      var ind = this.itemActivo.Pagos.findIndex(
        x => x.Id_TipoPago == item.Id_TipoPago
      );
      this.itemActivo.Pagos.splice(ind, 1);
      this.calcularTotalPago();
    },
    seleccionarTipoPago(nombre) {
      this.calcularTotalPago();
      if (
        this.itemActivo.TotalPagoPendiente > 0 ||
        this.esRecibo ||
        this.esModuloCaja
      ) {
        switch (nombre) {
          case this.$nombreTipoPago_Tarjeta:
            this.modalTipoPagoTarjetaEjecutarAccion("Mostrar");
            break;
          case this.$nombreTipoPago_Cheque:
            this.modalTipoPagoChequeEjecutarAccion("Mostrar");
            break;
          default:
            this.modalTipoPagoEfectivoEjecutarAccion("Mostrar");
            break;
        }
      }
    },
    modalTipoPagoEfectivoEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoEfectivoActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Efectivo;
          this.agregarPago(item);
          this.modalTipoPagoEfectivoActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoEfectivoActivo = false;
          break;
      }
    },
    modalTipoPagoTarjetaEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoTarjetaActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Tarjeta;
          this.agregarPago(item);
          this.modalTipoPagoTarjetaActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoTarjetaActivo = false;
          break;
      }
    },
    modalTipoPagoChequeEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoChequeActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Cheque;
          this.agregarPago(item);
          this.modalTipoPagoChequeActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoChequeActivo = false;
          break;
      }
    },
    agregarPago(item) {
      this.grillaLoading_Pagos = true;
      if (item.Importe > 0) {
        var ind = this.itemsTipoPago.findIndex(
          x => x.Nombre == item.NombreTipoPago
        );
        item.Id_TipoPago = this.itemsTipoPago[ind].Id_TipoPago;
        switch (item.NombreTipoPago) {
          case this.$nombreTipoPago_Tarjeta:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Tarjeta: item.Id_Tarjeta,
              Lote: item.Lote,
              NumeroCupon: item.NumeroCupon,
              Autorizacion: item.Autorizacion
            });
            break;
          case this.$nombreTipoPago_Cheque:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Banco: item.Id_Banco,
              NumeroChequeTercero: item.NumeroChequeTercero,
              FechaPago: item.FechaPago,
              Titular: item.Titular
            });
            break;
          default:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe
            });
        }
        this.calcularTotalPago();
      }
      this.grillaLoading_Pagos = false;
    },
    calcularTotalPago() {
      this.itemActivo.TotalPago = 0;
      if (this.itemActivo.Pagos) {
        this.itemActivo.TotalPago = this.itemActivo.Pagos.map(
          item => item.Importe
        ).reduce((a, b) => a + b, 0);
        if (this.esRecibo || this.esModuloCaja)
          this.itemActivo.Total = this.itemActivo.TotalPago;
      }
      this.itemActivo.TotalPagoPendiente =
        this.itemActivo.Total - this.itemActivo.TotalPago;
    },
    validarPago() {
      let ok =
        this.itemActivo.TotalPago >= this.itemActivo.Total ||
        !this.esVentaContado;
      if (!ok)
        this.mostrarMensaje(
          true,
          "Aviso",
          null,
          "Debe completar la forma de pago."
        );
      return ok;
    },
    finalizar() {
      if (
        this.$refs.form1.validate() &&
        this.itemActivo.Total > 0 &&
        this.validarPago()
      )
        this.ejecutarAccion("Guardar");
    },
    guardarItem(item) {
      this.snackActivo = true;
      if (this.esRecibo && this.sysId_TipoIva != "M")
        this.itemActivo.Articulos = [];
      if (!this.esVentaContado && !this.esRecibo) this.itemActivo.Pagos = [];
      if (this.esModuloCaja) this.guardarVale(item);
      else this.guardarVenta(item);
      setTimeout(() => {
        this.snackActivo = false;
      }, 2000);
    },
    guardarVenta(item) {
      HttpHelper.post("Venta", item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    guardarVale(item) {
      HttpHelper.post("Vale", item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
